<template>
    <div >
        <van-row >
            <van-col offset="9" span = "6" > 
                <van-image
                round
                width="100"
                height="100"
                src="https://img01.yzcdn.cn/vant/cat.jpeg"/>
            </van-col>
            <van-button type="primary" round style="margin-top:70px;" span = "2" size="mini">雷布斯</van-button>
            <van-button type="primary" round  span = "2" size="mini">2333</van-button>
        </van-row>
        <van-collapse v-model="activeNames">
            <van-collapse-item v-for=" (oitem,oid) in menuse"  :key="oid" :name="oid" >
                <template #title>
                    <div>{{ oitem.name}} <van-icon name="question-o" /></div>
                </template>
                    <van-cell v-for = "(item,id) in list" :key = "id"  :title="item.theme" :value="item.label" :label="item.label" is-link />
            </van-collapse-item>
        </van-collapse>
    </div>
  </template>
  <script>
    import { Search } from 'vant';
    import  SERVICE_URL from '@/api/url'
    export default {
      name : 'centerMenuList',
      data () {
        return {
            activeNames :["1"],
            menuse :[{name :"菜单1",  id : 1 },{name :"菜单2",  id : 2 }],
            indexList : [1,2,3],
            list :[{theme :"菜单1", label :"标签1", val : "value1" , id :1 },{theme :"菜单2", label :"标签2", val : "value2" , id :2 }]
        }
      },
      mounted () {
      
      },
      methods: {
       
      }
    }
  </script>
  
  <style lang="less" scoped>
    
  </style>
  


// WEBPACK FOOTER //
// src/mini_pages/center/centerMenuList.vue